module.exports = __webpack_public_path__ + "static/functions-screen-8-d98b7372a35029a225a375a7728a631a.png";